import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnauthorizedError = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 118,
	height: 91,
	fill: "none",
	viewBox: "0 0 118 91",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_20759_19826)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M26.4532 90.1717H12.7148C11.8338 90.1725 10.9681 89.9416 10.2048 89.5021C9.4415 89.0626 8.80753 88.43 8.36666 87.6681C7.92579 86.9061 7.69357 86.0416 7.69336 85.1615C7.69315 84.2814 7.92496 83.4168 8.36547 82.6547L12.3926 75.7008L29.8705 45.5293L51.3411 8.3809C51.7815 7.61954 52.4148 6.98736 53.1772 6.54785C53.9396 6.10833 54.8044 5.87695 55.6847 5.87695C56.565 5.87695 57.4297 6.10833 58.1922 6.54785C58.9546 6.98736 59.5878 7.61954 60.0283 8.3809L81.4988 45.5293L102.969 82.6777C103.404 83.4384 103.631 84.2995 103.628 85.1752C103.626 86.051 103.393 86.9108 102.955 87.6689C102.516 88.427 101.886 89.057 101.127 89.4962C100.369 89.9353 99.5082 90.1682 98.6316 90.1717H34.0703"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M56.4868 56.4179C56.4868 56.6259 56.2764 59.0879 56.253 59.2844V59.3537C55.9907 60.3592 55.3937 61.248 54.5584 61.877C53.723 62.506 52.6978 62.8387 51.648 62.8213C50.6368 62.8179 49.6604 62.4554 48.8967 61.7999C48.133 61.1443 47.6328 60.2393 47.4872 59.2497L45.582 30.8967C45.582 30.7118 45.582 30.5269 45.582 30.3419C45.5805 29.5668 45.7336 28.7991 46.0324 28.0825C46.3313 27.366 46.7701 26.7148 47.3238 26.1662C47.8774 25.6176 48.5351 25.1823 49.259 24.8854C49.983 24.5884 50.7591 24.4355 51.5428 24.4355C54.8388 24.4355 58.2633 27.0824 58.2633 30.3419L56.7906 51.4477L56.4868 56.4179Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M52.1739 79.8238C55.4079 79.8238 58.0295 77.2312 58.0295 74.033C58.0295 70.8348 55.4079 68.2422 52.1739 68.2422C48.94 68.2422 46.3184 70.8348 46.3184 74.033C46.3184 77.2312 48.94 79.8238 52.1739 79.8238Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M108.586 82.7918L108.425 82.5086C107.945 81.5507 107.602 80.8698 107.466 80.5928L96.4331 61.9139L64.4365 7.30719C63.2557 5.27016 59.9267 5.47081 58.4356 7.66176L58.1686 8.04836C58.6619 8.06219 59.1437 8.1989 59.5694 8.44584C59.9951 8.69277 60.3509 9.04193 60.6039 9.46099L92.5957 64.3086L100.619 77.47C104.233 84.004 107.466 91.1297 90.5583 90.2516L102.953 90.6507C104.108 90.6507 104.782 90.5649 105.547 90.2516C106.312 89.9383 106.931 89.3599 107.466 88.7349C108.665 87.19 109.384 84.9033 108.586 82.7918Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M59.2684 58.6949C59.2858 58.891 59.2858 59.0883 59.2684 59.2844V59.3537C59.0066 60.3572 58.4114 61.2446 57.5784 61.8734C56.7454 62.5022 55.723 62.836 54.6751 62.8213C53.6665 62.8216 52.6921 62.4596 51.9332 61.8026C51.1743 61.1457 50.6825 60.2384 50.5493 59.2497L48.5274 30.8967C48.5274 30.7118 48.5274 30.5269 48.5274 30.3419C48.5258 29.5668 48.6789 28.7991 48.9777 28.0825C49.2766 27.366 49.7154 26.7148 50.2691 26.1662C50.8228 25.6176 51.4804 25.1823 52.2043 24.8854C52.9283 24.5884 53.7044 24.4355 54.4881 24.4355C57.7841 24.4355 61.2086 27.0824 61.2086 30.3419L59.2684 58.6949Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M55.3536 79.314C58.5876 79.314 61.2092 76.7214 61.2092 73.5232C61.2092 70.3251 58.5876 67.7324 55.3536 67.7324C52.1197 67.7324 49.498 70.3251 49.498 73.5232C49.498 76.7214 52.1197 79.314 55.3536 79.314Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CFD4DC",
				d: "M11.532 42.2769C12.0409 42.2769 12.5289 42.075 12.8887 41.7158C13.2485 41.3565 13.4507 40.8692 13.4507 40.3611C13.4507 39.853 13.2485 39.3657 12.8887 39.0064C12.5289 38.6472 12.0409 38.4453 11.532 38.4453C11.0231 38.4453 10.5351 38.6472 10.1753 39.0064C9.81543 39.3657 9.61328 39.853 9.61328 40.3611C9.61328 40.8692 9.81543 41.3565 10.1753 41.7158C10.5351 42.075 11.0231 42.2769 11.532 42.2769Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CFD4DC",
				d: "M107.171 53.1512C107.601 53.1512 108.014 52.982 108.319 52.6809C108.623 52.3797 108.795 51.9712 108.795 51.5453C108.795 51.1194 108.623 50.711 108.319 50.4098C108.014 50.1086 107.601 49.9395 107.171 49.9395C106.74 49.9395 106.327 50.1086 106.022 50.4098C105.718 50.711 105.547 51.1194 105.547 51.5453C105.547 51.9712 105.718 52.3797 106.022 52.6809C106.327 52.982 106.74 53.1512 107.171 53.1512Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFB5B5",
				d: "M5.54905 36.9674C6.26384 36.9674 6.96255 36.7576 7.55672 36.3646C8.15088 35.9717 8.61377 35.4132 8.88677 34.7599C9.15977 34.1066 9.23061 33.3879 9.09031 32.6948C8.95001 32.0016 8.60488 31.3652 8.09862 30.8662C7.59237 30.3672 6.94777 30.0279 6.24643 29.8914C5.54509 29.7549 4.81858 29.8273 4.15886 30.0994C3.49915 30.3715 2.93591 30.8311 2.54048 31.42C2.14505 32.0088 1.93521 32.7005 1.93752 33.4074C1.94061 34.3526 2.32248 35.2581 2.99944 35.9254C3.67639 36.5927 4.59324 36.9674 5.54905 36.9674Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#CBD1DC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.4,
				d: "M112.867 42.2773V50.9693"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#CBD1DC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.4,
				d: "M108.426 46.5762H117.309"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeLinecap: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M20.8751 90.1556H6.19521C5.25189 90.1601 4.32406 89.9185 3.50527 89.4553C2.68649 88.992 2.0057 88.3234 1.53157 87.5169C1.05743 86.7104 0.806715 85.7946 0.8047 84.8617C0.802685 83.9288 1.04944 83.0119 1.52009 82.2034L5.84457 74.8522L24.5451 42.8467L47.5349 3.46693C48.0034 2.65749 48.6798 1.9848 49.4956 1.51696C50.3114 1.04912 51.2378 0.802734 52.1808 0.802734C53.1239 0.802734 54.0503 1.04912 54.8661 1.51696C55.6819 1.9848 56.3583 2.65749 56.8267 3.46693L79.8283 42.8467L102.853 82.238C103.315 83.0456 103.555 83.9588 103.549 84.8866C103.542 85.8144 103.29 86.7243 102.817 87.5256C102.344 88.3268 101.666 88.9913 100.852 89.4528C100.038 89.9143 99.1164 90.1566 98.1782 90.1556H29.0332"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M56.4868 56.4179C56.4868 56.6259 56.2764 59.0879 56.253 59.2844V59.3537C55.9907 60.3592 55.3937 61.248 54.5584 61.877C53.723 62.506 52.6978 62.8387 51.648 62.8213C50.6368 62.8179 49.6604 62.4554 48.8967 61.7999C48.133 61.1443 47.6328 60.2393 47.4872 59.2497L45.582 30.8967C45.582 30.7118 45.582 30.5269 45.582 30.3419C45.5805 29.5668 45.7336 28.7991 46.0324 28.0825C46.3313 27.366 46.7701 26.7148 47.3238 26.1662C47.8774 25.6176 48.5351 25.1823 49.259 24.8854C49.983 24.5884 50.7591 24.4355 51.5428 24.4355C54.8388 24.4355 58.2633 27.0824 58.2633 30.3419L56.7906 51.4477L56.4868 56.4179Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M52.1739 79.8238C55.4079 79.8238 58.0295 77.2312 58.0295 74.033C58.0295 70.8348 55.4079 68.2422 52.1739 68.2422C48.94 68.2422 46.3184 70.8348 46.3184 74.033C46.3184 77.2312 48.94 79.8238 52.1739 79.8238Z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_20759_19826",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 118,
			height: 91,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgUnauthorizedError);
export default ForwardRef;
